/* eslint-disable no-await-in-loop */
import { useEffect, useState } from 'react'
import EntidadeService from '../../services/EntidadeService'

interface Data {
    nome: string,
    total: number
}

const initialState: Data[] = [
    { nome: 'Startup', total: 0 },
    { nome: 'Aceleradora', total: 0 },
    { nome: 'Investidor', total: 0 },
    { nome: 'Projeto', total: 0 }
]

const getData = async (data: Data[]) => {
    const newData:Data[] = []
    const res = await EntidadeService.getCountTipos()
    data.forEach((item) => {
        const { nome } = item
        const CountTipo = res.find((tipo) => {
            return tipo.tipo_entidade__nome === nome
        })
        const total = CountTipo ? CountTipo.total : 0
        newData.push({ nome, total })
    })

    return Promise.resolve(newData)
}

export function useDadosEcossistema() {
    const [data, setData] = useState<Data[]>(initialState)

    useEffect(() => {
        getData(data).then((newData) => {
            setData(newData)
        })
    }, [])

    return { data }
}
